import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG, CONFIG_API_BE, URL_AKM } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import akmApi from '../../../../../apis/akmApi';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import {Row, Col, Alert,Form} from 'react-bootstrap';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import {Bar} from 'react-chartjs-2';

import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';


import './report.css';


class ReportSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching : false,
            alertShow: false,
            resMessage: "message",
            tahunAjaran : [],
            provinsi: [],
            kota: [],
            sekolah: [],
            idProvinsi : null,
            idKota : null,
            idSekolah : null,
            namaSekolahSearch : null,
            taAktif : null,
            siswa : '',
            kategoriMapelLit: '',
            deskripsiMapelLit: '',
            kategoriMapelNum: '',
            deskripsiMapelNum: '',
            dataInfo: {},
            dataMapel: [],
            dataIndikator: [],
            dataSK: [],
            dataSLB: [],
            dataIndekSosial: []
        }
    }

    async componentDidMount() { 
        //await this.props.cekCookies();
        //if(!__.isEmpty(this.props.account)) {
            this.fetchReport();
        //}
        const queryParams = new URLSearchParams(this.props.location.search);
        console.groupCollapsed("========== rptakmsiswa ==========");
        console.info('props', this.props);
        console.info('queryParams', queryParams.get('idSiswa'));
        console.info('idJadwal', queryParams.get('idJadwal'));
        console.info('idSekolah', queryParams.get('idSekolah'));
        console.info('idKelas', queryParams.get('idKelas'));
        console.info('idKelasParalel', queryParams.get('idKelasParalel'));
        console.groupEnd();
    }

    fetchReport = async() => {   
        const queryParams = new URLSearchParams(this.props.location.search);
        const patch = 
                        queryParams.get('idSiswa')+'/'+
                        queryParams.get('idJadwal')+'/'+
                        queryParams.get('idSekolah')+'/'+
                        queryParams.get('idKelas')+'/'+
                        queryParams.get('idKelasParalel');
        this.setState({isFetching:true })     
        // const patch = 
        //                 this.props.match.params.idSiswa+'/'+
        //                 this.props.match.params.idJadwal+'/'+
        //                 this.props.match.params.idSekolah+'/'+
        //                 this.props.match.params.idKelas+'/'+
        //                 this.props.match.params.idKelasParalel;

        const response = await eduprimeApi.get(CONFIG_API_BE.REPORT_SISWA_AKM + patch, {})
        if(response){
            if(response.data){
                this.setState({ 
                    dataInfo: response.data,
                    dataMapel: response.data.dataMapel,
                    dataIndikator: response.data.dataIndikator,
                    dataSK: response.data.dataNonAkademik.SK === undefined ? [] : response.data.dataNonAkademik.SK,
                    dataSLB: response.data.dataNonAkademik.SLB === undefined ? [] : response.data.dataNonAkademik.SLB                    
                });

                response.data.dataMapel.map(item => {
                    let nama = item.namaMataPelajaran
                    if('LITERASI' === nama){
                        let kategori = item.kategori.nama;
                        let deskripsi = item.kategori.deskripsi;
                        this.setState({
                            kategoriMapelLit: kategori,
                            deskripsiMapelLit: deskripsi
                        });
                    }
                    if('NUMERASI' === nama){
                        let kategori = item.kategori.nama;
                        let deskripsi = item.kategori.deskripsi;
                        this.setState({
                            kategoriMapelNum: kategori,
                            deskripsiMapelNum: deskripsi
                        });
                    }
                })

            } 
            this.setState({isFetching:false})
        }        
    } 


    render(){
        const {siswa, dataInfo, dataMapel, dataIndikator,dataSK, dataSLB, dataIndekSosial} = this.state;
        return(
            <div className="container-fluid" style={{paddingBottom: '50px'}}>
                <LoaderModal isFetching={this.state.isFetching}/> 
                {this.loadAlert()}
                <Row>
                    <Col>
                        <div className="header-title-1">
                            ASSESMENT REPORT
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="header-title-2">
                            SIMULASI ASESMEN NASIONAL – EDUPRIME
                        </div>
                    </Col>
                </Row>
                <br></br>

                {/* =========== BIODATA  ========== */}
                <Row>
                    <Col>
                        <div className="biodata-kiri">
                            Nama : {dataInfo.siswa}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Sekolah : {dataInfo.sekolah}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="biodata-kiri">
                        Kelas : {dataInfo.kelas}
                        </div>
                    </Col>
                    <Col>
                        <div className="biodata-kiri">
                            Tgl. Test : {dataInfo.tanggal} 
                        </div>
                    </Col>
                </Row>
                <br></br>
                <hr />

                {/* ===================== AKM ======================== */}
                <Row>
                    <Col>
                        <div className="judul-akm ">
                            ASESMEN KOMPETENSI MINIMUM
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}>
                        {this.renderChart('LITERASI')}
                    </Col>
                    <Col sm={3}>
                        {this.renderChart('NUMERASI')}
                    </Col>
                    <Col sm={6}>
                        <br />
                        <table width="100%" border="1">
                            <thead>
                                <tr>
                                    <th className="text-center">Subtes</th>
                                    <th className="text-center">Soal Benar</th>
                                    <th className="text-center">Rata Kelas</th>
                                    <th className="text-center">Rata Sekolah</th>
                                    <th className="text-center">Kategori</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataMapel.map((sub,i)=>
                                        <tr key={i}>
                                            <td className="text-center">{sub.namaMataPelajaran}</td>    
                                            <td className="text-center">{sub.jmlBenar}</td>    
                                            <td className="text-center">{sub.rataKelas}</td>    
                                            <td className="text-center">{sub.rataSekolah}</td>    
                                            <td className="text-center">{sub.kategori.nama}</td>            
                                        </tr>
                                    )
                                }
                                {/* <tr>
                                    <td colSpan="2"  className="text-center">Rata - rata</td>
                                    <td  className="text-center">2</td>
                                    <td  className="text-center">2</td>    
                                    <td  className="text-center">&nbsp;</td>                                    
                                </tr> */}
                            </tbody>
                        </table>
                    </Col>
                </Row>

                <hr className="garis"></hr>
                <Row>
                    <Col>
                        <p style={{"text-align": "center"}}>Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum pada subtes <strong>LITERASI</strong> anda termasuk dalam kategori <strong>{this.state.kategoriMapelLit}, {this.state.deskripsiMapelLit}</strong>.</p>
                        <p style={{"text-align": "center"}}>Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum pada subtes <strong>NUMERASI</strong> anda termasuk dalam kategori <strong>{this.state.kategoriMapelNum}, {this.state.deskripsiMapelNum}</strong>.</p>
                        <br />
                        <p style={{"text-align": "center"}}>Secara umum, Berdasarkan hasil pengerjaan Asesmen Kompetensi Minimum anda termasuk dalam kategori</p>
                    </Col>
                </Row>
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-akm" style={{"width": "300px"}}>
                            {dataInfo.keteranganAsm} 
                        </div>
                    </Col>
                </Row>
                <hr></hr>

                {/* =============================== ANALISIS PENCAPAIAN INDIKATOR ================================ */}
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-analisispencapaianindikator">
                            ANALISIS PENCAPAIAN INDIKATOR
                        </div>
                    </Col>
                </Row>
                {
                    dataIndikator.map((mapel, i) =>
                        <> 
                            <Row key={i+1}>
                                <Col><b>{mapel.namaMataPelajaran}</b></Col>
                            </Row>
                            <Row key={i+2}>
                                {/* <Col sm={5}>Grafik</Col> */}
                                <Col sm={12}>
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Indikator</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                mapel.indikator.map((dt, j)=>
                                                    <tr key={j}>
                                                        <td style={{"padding": "0px"}}>
                                                            {dt.namaIndikator}
                                                        </td>
                                                        <td className="text-center" style={{"padding": "0px"}}>
                                                            {
                                                                dt.tuntas ? <DoneAllIcon style={{"color": "green"}}/>:<CancelPresentationIcon style={{"color": "red"}}/>
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </>
                    )
                    
                }


                <hr className="garis"></hr>
                
                {/* ====================================== SK =============================== */}
                <Row>
                    <Col>
                        <div className="judul-sk ">
                            SURVEY KARAKTER
                        </div>
                    </Col>
                </Row>
                <div className="row" style={{"marginTop" : "10px"}}>
                    <div className="col-md-12">
                        <div className="row">
                        {/* == GRAFIK == */}
                            <div className="col-md-6">
                                {/* looping */}
                                {dataSK.map((data,i) => 
                                <>
                                <div className="row" key={i}>
                                    <div className="col-md-6">
                                        {data.aspek}
                                    </div>
                                    <div className="col-md-6">
                                        <div className="graph">
                                            <div className="bg-graph val-graph" style={{ width: data.skor + '%' }}></div>
                                        </div> 
                                    </div>
                                </div>
                                <hr className="divider"></hr>
                                </>
                               
                                )}  
                            </div>
                            
                            {/* == TABEL == */}
                            <div className="col-md-6">
                                <div className="row">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Profil Pelajar Pancasila</th>
                                                <th>Skor</th>
                                                <th>Kategori</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* diloop */}
                                            {dataSK.map((data,i) => 
                                            <tr key={i}>
                                                <td>{data.aspek}</td>
                                                <td className="text-center">{data.skor}</td>
                                                <td className="text-center">{data.kategori}</td>
                                            </tr>
                                            )} 
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>

                {/* ====================================== AHSK =============================== */}
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                        <div className="judul-hasilanalisissurveykarakter">
                            ANALISIS HASIL SURVEI KARAKTER
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col style={{"text-align": "-webkit-center"}}>
                    <p style={{"text-align": "center"}}>
                        Berdasarkan hasil pengerjaan siswa terkait survei yang dilakukan oleh Eduprime (mengenai Survei Karakter
                        dengan tema Profil Pelajar Pancasila), diperoleh hasil sebagai berikut:</p>
                    </Col>
                </Row>
                <br />
                {dataSK.map((data,i) =>
                <Row key={i}>
                    <Col>
                            <div className="sub-heading2-ahsk">{data.aspek}</div>
                            <div className="sub-heading3-ahsk">
                                <p style={{"text-align": "center"}}>
                                    {data.deskripsi}
                                </p>
                            </div>
                            <br />
                    </Col>
                </Row>
                )}
            </div>
        );
    }

    renderChart(mapel) {

        let title = mapel;
        let data = [];
        let label = ['Skor', 'Rata Kelas', 'Rata Sekolah'];

        this.state.dataMapel.map(item => {
            let nama = item.namaMataPelajaran
            if(mapel === nama){
                data.push(item.skor);
                data.push(item.rataKelas);
                data.push(item.rataSekolah);
            }
        })
        
        return(
            <>
                <Bar
                    data={{
                        labels: label,
                        datasets: [
                            {
                                label: title,
                                data: data,
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(255, 206, 86, 0.2)',
                                    'rgba(75, 192, 192, 0.2)'
                                ],
                                borderColor: [
                                    'rgba(255, 99, 132, 1)',
                                    'rgba(255, 206, 86, 1)',
                                    'rgba(75, 192, 192, 1)'
                                ],
                                borderWidth: 0
                            }
                        ]
                    }}
                    height="260px"
                    options = {{  
                        legend: {
                        },                      
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                }
                            }],
                        }                        
                    }}
                />
                
            </>             
        )
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
        
    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  

}
//const mapStateToProps = (state) => {
//    return{
//        account: state.account
//    };
//}

//export default connect(mapStateToProps, {cekCookies})(ReportSiswa);

export default ReportSiswa;